import React, { useState } from 'react';
import { ActivityIndicator, Pressable, StyleSheet, Text, TextInput, View } from 'react-native';
import { useDispatch } from 'react-redux';
import { serviceResponse } from '../../../services/common';
import { createPosition, isPositionNameAvailable, getPositions, Position } from '../../../services/Position';
import { setLocalPositions } from '../../../services/store/common';
import { colors, globalStyles } from '../../Shared';
import SettingsHeader from '../Header';

interface Props {
    onBack: () => void
}

export default function CreatePosition({ onBack }: Props) {
    const dispatch = useDispatch();
    const [name, setName] = useState("");
    const [isLoading, setIsLoading] = useState(false);

    const getPositionsToSet = async () => {
        const req = await getPositions();

        if (req === serviceResponse.systemError) {
            return alert("Seomthing went wrong, please try it again");
        }
        const positions = req as Position[];
        dispatch(setLocalPositions(positions));
    }

    const next = async () => {
        if (!name || isLoading) {
            return;
        }

        setIsLoading(true);

        const isNameOk = await isPositionNameAvailable(name.toLowerCase());
        if (isNameOk === serviceResponse.systemError) {
            setIsLoading(false);
            return alert("Something went wrong, please try it again");
        }

        if (isNameOk === serviceResponse.actionDenied) {
            setIsLoading(false);
            return alert("This name is not available");
        }

        const create = await createPosition(name);

        if (create === serviceResponse.systemError || create === serviceResponse.emptyFields) {
            setIsLoading(false);
            return alert("Something went wrong, please try it again");
        }
        await getPositionsToSet();
        onBack();
        setIsLoading(false);
    }

    return <View style={styles.container}>
        <SettingsHeader onBack={onBack} title="Create position" />


        <View style={{ flex: 1, justifyContent: 'center', alignItems: 'center' }}>
            <TextInput
                style={[
                    globalStyles.transparentBorderInput,
                    { width: '80%', paddingLeft: 5 },
                ]}
                placeholder="Name"
                placeholderTextColor="#d8d8d8"
                onChangeText={setName}
                blurOnSubmit={false}
                value={name}
                onSubmitEditing={next}
                keyboardType="default"
            />
        </View>

        <View style={styles.footerContainer}>
            <Pressable style={styles.footerButton} onPress={next}>
                {isLoading && <ActivityIndicator />}
                {!isLoading && <Text style={{ color: colors.text.white }}>Continuar</Text>}
            </Pressable>
        </View>

    </View>
}

const styles = StyleSheet.create({
    container: {
        flex: 1
    },
    footerContainer: {
        // backgroundColor: 'red',
        padding: 10,
    },
    footerButton: {
        marginHorizontal: 'auto',
        height: 50,
        borderRadius: 5,
        backgroundColor: colors.bg.primary,
        width: "35%",
        justifyContent: 'center',
        alignItems: 'center'
    }
});